import React from 'react'

import { Checkbox } from '@/shared/components/ui/checkbox-native'

export function BasicCheckboxField(props: { value: boolean }) {
	const checked = Boolean(props.value)

	return <Checkbox className='pointer-events-none m-auto' checked={checked} />
}
